import { render, staticRenderFns } from "./FlagForm.vue?vue&type=template&id=5ffc952f&scoped=true&"
import script from "./FlagForm.vue?vue&type=script&lang=js&"
export * from "./FlagForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffc952f",
  null
  
)

export default component.exports